import { render, staticRenderFns } from "./DesktopHeader.vue?vue&type=template&id=0cb6f659&scoped=true"
import script from "./DesktopHeader.vue?vue&type=script&lang=js"
export * from "./DesktopHeader.vue?vue&type=script&lang=js"
import style0 from "./DesktopHeader.vue?vue&type=style&index=0&id=0cb6f659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6f659",
  null
  
)

export default component.exports